import { render, staticRenderFns } from "./MiniWizardManagerGeneral.vue?vue&type=template&id=6090b3fe&"
import script from "./MiniWizardManagerGeneral.vue?vue&type=script&lang=js&"
export * from "./MiniWizardManagerGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports